{
  "name": "kh.public-coordinate.web.client",
  "version": "1.2.5-8",
  "private": true,
  "scripts": {
    "ng": "ng",
    "start": "run-script-os",
    "prebuild": "npm run clean:esproj",
    "build": "ng build --source-map true",
    "clean": "npm run clean:angular && npm run clean:dist && npm run clean:esproj",
    "clean:angular": "ng cache clean",
    "clean:dist": "shx rm -rf dist",
    "clean:esproj": "shx rm -rf obj",
    "watch": "ng build --watch --configuration development",
    "test": "vitest",
    "test:ci": "vitest run --coverage",
    "icons": "npm run icons:update && npm run icons:metadata && npm run icons:sprite && npm run prettier:fix",
    "icons:update": "npm install @material-symbols/svg-400@latest",
    "icons:metadata": "pwsh -noprofile -file ../scripts/Generate-IconMetadata.ps1",
    "icons:sprite": "pwsh -noprofile -file ../scripts/Generate-SvgSprite.ps1",
    "lint": "ng lint --cache --cache-strategy content",
    "lint:ci": "ng lint --cache --cache-strategy content --format=azure-devops",
    "lint:fix": "ng lint --cache --cache-strategy content --fix && npm run prettier:fix && npm run lint:types",
    "lint:types": "tsc --noEmit",
    "prettier": "prettier . ../docs ../.azure-pipelines ../README.md --check --cache --end-of-line auto",
    "prettier:fix": "prettier . ../docs ../scripts ../.azure-pipelines ../README.md --write --log-level warn --cache --end-of-line auto",
    "prestart": "node aspnetcore-https",
    "start:windows": "ng serve --ssl --ssl-cert \"%APPDATA%\\ASP.NET\\https\\%npm_package_name%.pem\" --ssl-key \"%APPDATA%\\ASP.NET\\https\\%npm_package_name%.key\" --host=localhost",
    "start:default": "ng serve --ssl --ssl-cert \"$HOME/.aspnet/https/${npm_package_name}.pem\" --ssl-key \"$HOME/.aspnet/https/${npm_package_name}.key\" --host=localhost",
    "storybook": "ng run kh.public-coordinate.web.client:storybook",
    "build-storybook": "ng run kh.public-coordinate.web.client:build-storybook",
    "storybook:build": "ng run kh.public-coordinate.web.client:build-storybook",
    "prestorybook:test": "npx playwright install chromium --with-deps",
    "storybook:test": "test-storybook --url http://localhost:6006 --maxWorkers=1",
    "prestorybook:test:ci": "npx playwright install-deps --dry-run && npx playwright install chromium --dry-run && npx playwright install chromium",
    "storybook:test:ci": "start-server-and-test storybook:test:ci:start http://localhost:6006 storybook:test:ci:run",
    "storybook:test:ci:start": "http-server dist/storybook -p 6006 -a localhost --silent",
    "storybook:test:ci:run": "test-storybook --junit --failOnConsole --ci --url http://localhost:6006",
    "chromatic": "chromatic --config-file chromatic.config.json"
  },
  "dependencies": {
    "@angular/animations": "^19.2.15",
    "@angular/cdk": "^19.2.19",
    "@angular/common": "^19.2.15",
    "@angular/compiler": "^19.2.15",
    "@angular/core": "^19.2.15",
    "@angular/forms": "^19.2.20",
    "@angular/material": "^19.2.19",
    "@angular/material-luxon-adapter": "^19.2.19",
    "@angular/platform-browser": "^19.2.15",
    "@angular/platform-browser-dynamic": "^19.2.20",
    "@angular/router": "^19.2.20",
    "@azure/msal-browser": "^4.30.0",
    "@mapbox/geojson-extent": "^1.0.1",
    "@mapbox/mapbox-gl-draw": "^1.5.1",
    "@material-symbols/svg-400": "^0.40.2",
    "@microsoft/applicationinsights-angularplugin-js": "^15.3.8",
    "@microsoft/applicationinsights-web": "^3.4.1",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@placemarkio/check-geojson": "^0.1.14",
    "@zumer/snapdom": "^2.8.0",
    "angularx-qrcode": "^19.0.0",
    "dompurify": "^3.3.3",
    "embla-carousel": "^8.6.0",
    "geojson": "^0.5.0",
    "gridstack": "^12.6.0",
    "luxon": "^3.7.2",
    "mapbox-gl": "^3.21.0",
    "match-container": "^0.1.1",
    "ngx-editor": "^19.0.0-beta.1",
    "rxjs": "^7.8.2",
    "shpjs": "^6.2.0",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@analogjs/vite-plugin-angular": "^2.4.3",
    "@analogjs/vitest-angular": "^2.4.3",
    "@angular-devkit/architect": "^0.1902.20",
    "@angular-devkit/build-angular": "^19.2.23",
    "@angular-devkit/core": "^19.2.19",
    "@angular/cli": "^19.2.23",
    "@angular/compiler-cli": "^19.2.20",
    "@chromatic-com/storybook": "^4.1.3",
    "@compodoc/compodoc": "^1.2.1",
    "@storybook/addon-a11y": "^10.3.5",
    "@storybook/addon-designs": "^11.1.3",
    "@storybook/addon-docs": "^10.3.5",
    "@storybook/addon-themes": "^10.3.5",
    "@storybook/angular": "^10.3.5",
    "@storybook/test-runner": "^0.24.3",
    "@testing-library/angular": "^17.4.0",
    "@testing-library/dom": "^10.4.1",
    "@testing-library/jest-dom": "^6.9.1",
    "@testing-library/user-event": "^14.6.1",
    "@types/luxon": "^3.7.1",
    "@types/mapbox__geojson-extent": "^1.0.3",
    "@types/mapbox__mapbox-gl-draw": "^1.4.9",
    "@types/shpjs": "^3.4.7",
    "@vitest/coverage-v8": "^4.0.18",
    "angular-eslint": "^19.8.1",
    "chromatic": "^13.3.5",
    "eslint": "^9.39.4",
    "eslint-config-prettier": "^10.1.8",
    "eslint-formatter-azure-devops": "^1.2.1",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-simple-import-sort": "^12.1.1",
    "eslint-plugin-storybook": "^10.3.5",
    "happy-dom": "^20.8.9",
    "http-server": "^14.1.1",
    "msw": "^2.13.2",
    "msw-storybook-addon": "^2.0.7",
    "playwright": "^1.59.1",
    "prettier": "^3.8.1",
    "run-script-os": "^1.1.6",
    "shx": "^0.4.0",
    "start-server-and-test": "^2.1.5",
    "storybook": "^10.3.5",
    "storybook-addon-test-codegen": "^3.0.1",
    "typescript": "~5.8.3",
    "typescript-eslint": "^8.60.1",
    "vite-tsconfig-paths": "^5.1.4",
    "vitest": "^4.0.17",
    "vitest-canvas-mock": "^1.1.4"
  },
  "imports": {
    "#/*": "./src/*"
  },
  "msw": {
    "workerDirectory": [
      "static"
    ]
  },
  "overrides": {
    "storybook": "$storybook"
  },
  "devEngines": {
    "runtime": {
      "name": "node",
      "version": "^22.23.4"
    },
    "packageManager": {
      "name": "npm",
      "version": ">=10.9.2"
    }
  },
  "engines": {
    "npm": ">=10.9.2",
    "node": "^22.23.4"
  },
  "volta": {
    "node": "22.23.4"
  }
}
